import Point from "./point.js"

class billboardPoint extends Point{
  constructor(obj){
    super(obj)

    const { imageUrl, scale, scaleHL } = obj

    this._highlightOptions = {
      ...this._highlightOptions,
      scale: scaleHL !== null ? scaleHL : 1.0
    }
    this._styleOptions = {
      ...this._styleOptions,
      image: imageUrl ? imageUrl : '',
      scale: scale !== null ? scale : 1.0,
      highlight: this._highlight ? this._highlightOptions : {},
    }
    this._symbol = {
      ...this._symbol,
      type: 'billboardP',
      styleOptions: this._styleOptions
    }
    this._initObj = {
      ...this._initObj,
      symbol: this._symbol
    }
  }
}

export default billboardPoint